import { render, staticRenderFns } from "./ConsignmentViewPage.vue?vue&type=template&id=1ea3fcb5&"
import script from "./ConsignmentViewPage.vue?vue&type=script&lang=js&"
export * from "./ConsignmentViewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports